import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { ZoomDialog } from '@component/Dialog/ZoomDialog';
import { PartsProduct } from '@app/react/const/type';
import { AppState } from '@app/react/reducer';
import { OrderPartsType } from '@app/react/const/variables';

const selectOpenPartsName = (
    state: AppState,
): OrderPartsType | null => state.pageOpenDetection.partsName;

interface ZoomDialogContainerProps {
    isShow: boolean;
    setisshow: (v: boolean) => void;
    product: PartsProduct;
}

export const ZoomDialogContainer: FC<ZoomDialogContainerProps> = ({
    isShow,
    setisshow,
    product,
}) => {
    const openedPartsName = useSelector(selectOpenPartsName);

    return (
        <ZoomDialog
            isShow={isShow}
            setisshow={setisshow}
            product={product}
            openPartsName={openedPartsName}
        />
    );
};
